module.exports = __webpack_public_path__ + "static/media/ico_arrow_on.9bcb2ed7.svg";